import React, { Component } from 'react';
import {
    Button,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch, faHandHoldingDollar, faHandshake } from '@fortawesome/free-solid-svg-icons'

class ListOpportunities extends Component {

    formatDate = (d) => {
        if (parseInt(String(d).substring(0, 4)) <= 2000) return "";
        return parseInt(String(d).substring(5, 7)) + '/' + parseInt(String(d).substring(8, 10)) + '/' + parseInt(String(d).substring(0, 4));
    }

    formatDateTime = (date) => {
        if (!date) return null;
        if (!(date instanceof Date)) {
            date = new Date(date);
            if (isNaN(date.getTime())) return date;
        }
        const utcMonth = date.getUTCMonth() + 1; // Months are zero-based
        const utcDay = date.getUTCDate();
        const utcYear = date.getUTCFullYear();
        const utcHours = date.getUTCHours();
        const utcMinutes = date.getUTCMinutes();

        // Format time to am/pm
        const period = utcHours >= 12 ? "PM" : "AM";
        const formattedHours = utcHours % 12 || 12; // Convert to 12-hour format
        const formattedMinutes = utcMinutes.toString().padStart(2, "0");

        const formattedDate = `${utcMonth}/${utcDay}/${utcYear} ${formattedHours}:${formattedMinutes} ${period}`;
        return formattedDate;
    }

    render() {

        return (
            <tr onClick={() => this.props.onEdit(this.props.row.ID)} className="pointer">
                <td>
                    {this.props.row['WA#'] || `WA${this.props.row.ID}`}
                </td>
                <td>
                    {this.props.row['Sales Opportunity Name']} {!this.props.row['Active'] && <span className="commentTag">Inactive</span>}
                </td>
                <td>
                    {this.formatDate(this.props.row['Sales Opportunity Date'])}
                </td>
                <td>
                    {this.props.row['Opportunity Amount'] != null ? '$' + Intl.NumberFormat().format(this.props.row['Opportunity Amount']) : ''}
                </td>
                <td>
                    {this.props.row['Contact Name'] != null ? this.props.row['Contact Name'] : '--'}
                    {this.props.row['Contact Active'] != null && !this.props.row['Contact Active'] ? ' (Inactive}' : ''}
                </td>
                <td>
                    {this.props.row.Type != null ? this.props.row.Type : '--'}
                </td>
                <td>
                    {this.props.row.Status != null ? this.props.row.Status : '--'}
                </td>
                <td>
                    {this.props.row.Stage != null ? this.props.row.Stage : '--'}
                </td>
                <td>
                    {this.props.row.Source != null ? this.props.row.Source : '--'}
                </td>
                <td>
                    {this.props.row['Opportunity Assignee User ID'] != null && this.props.row['Opportunity Assignee User ID'] !== '' && this.props.row['Opportunity Assignee User ID'] !== '0' ?
                        this.props.row['Opportunity Assignee User First Name'] + ' ' + this.props.row['Opportunity Assignee User Last Name']
                        : (
                            this.props.row['Opportunity Assignee User Other'] != null ? this.props.row['Opportunity Assignee User Other'] : '--'
                        )}
                </td>
                <td>
                    {this.props.row['Opportunity Sales Rep User ID'] != null && this.props.row['Opportunity Sales Rep User ID'] !== '' && this.props.row['Opportunity Sales Rep User ID'] !== '0' ?
                        this.props.row['Opportunity Sales Rep User First Name'] + ' ' + this.props.row['Opportunity Sales Rep User Last Name']
                        : (
                            this.props.row['Opportunity Sales Rep User Other'] != null ? this.props.row['Opportunity Sales Rep User Other'] : '--'
                        )}
                </td>
                <td>
                    {this.props.row.Timestamp != null ? this.formatDateTime(new Date(this.props.row.Timestamp)) : '--'}
                </td>
                <td className='text-right nowrap'>
                    {this.props.type !== 'Sale' ?
                        <Button
                            color="success"
                            className='mr-2'
                            onClick={(e) => { e.stopPropagation(); this.props.convertToSaleOpportunity(this.props.row, true) }}
                            title="Convert to Sale"
                        >
                            <FontAwesomeIcon icon={faHandHoldingDollar} />
                        </Button> :
                        <Button
                            color="success"
                            className='mr-2'
                            onClick={(e) => { e.stopPropagation(); this.props.convertToSaleOpportunity(this.props.row, false) }}
                            title="Convert to Opportunity"
                        >
                            <FontAwesomeIcon icon={faHandshake} />
                        </Button>}
                    <Button
                        color="secondary"
                        className='mr-2'
                        onClick={(e) => { e.stopPropagation(); this.props.onPreview(this.props.row) }}
                        title="Preview"
                    >
                        <FontAwesomeIcon icon={faSearch} />
                    </Button>

                </td>
            </tr>
        )
    }
}

export default ListOpportunities;
